<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue';

import { io } from 'socket.io-client';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { applyScheme, getSavedScheme, getSystemScheme, initSystemSchemeListener } from '@/utils/colorSchemeUtils.js';

import defaultLayout from './layouts/default.vue';
import guestLayout from './layouts/guest.vue';

const logOut = payload => store.dispatch('logOut', payload);
const addAuthStatus = status => store.dispatch('addAuthStatus', status);
const getReportPost = id => store.dispatch('fetchReportBotId', id);
const handleSetProfile = data => store.dispatch('fetchCurrentProfileOrg', data);
const userdata = JSON.parse(localStorage.getItem('user'));
const user = computed(() => store.getters.getUser);
const isUserAuth = computed(() => store.getters.getAuthStatus);
const route = useRoute();
const store = useStore();
const layout = computed(() => {
  const layout = route.meta.layout;
  return layout === 'default' ? defaultLayout : guestLayout;
});
let unregisterSystemSchemeListener;

const useSocketIO = () => {
  const socket = io('/', {
    transports: ['websocket'],
  });
  
  socket.on('connect', () => {
    console.log('✅ WebSocket connected successfully');
  });
  
  socket.on('disconnect', () => {
    console.log('❌ WebSocket disconnected');
  });
  
  socket.on('connect_error', (error) => {
    console.error('❌ WebSocket connection error:', error);
  });
  
  socket.on('post_marked_bot', payload => {
    getReportPost(payload.postId);
  });
  
  socket.on('new_notification', async () => {
    console.log('🔔 New notification received via WebSocket');
    
    // Fetch updated unread notifications count
    await store.dispatch('fetchUnreadNotificationsCount');
    
    // Optionally fetch new unread notifications to update the list
    // Only do this if user is on notifications page to avoid unnecessary API calls
    const currentRoute = route.path;
    if (currentRoute === '/notifications') {
      console.log('📱 User is on notifications page, refreshing notifications list');
      await store.dispatch('fetchNotifications', { read: false, limit: 10, offset: 0 });
    }
  });
};

onMounted(async () => {
  try {
    let userdata = await store.dispatch('getMe');
    handleSetProfile(userdata);
    applyScheme(getSavedScheme() || getSystemScheme());
    unregisterSystemSchemeListener = initSystemSchemeListener();
    
    // If user is authenticated, set up notifications and WebSocket
    if (userdata) {
      store.dispatch('startGlobalTimer');
      store.dispatch('fetchReputationCategories');
      store.dispatch('fetchUnreadNotificationsCount');
      useSocketIO();
    }
  } catch (error) {
    console.warn(error);
  }
});

onUnmounted(() => {
  if (unregisterSystemSchemeListener) {
    unregisterSystemSchemeListener();
  }
});
</script>
